package com.github.aborg0.oeis.ui

object CssConstants {
  val SpaceOnRight = "spaceOnRight"
}
